import React from 'react';
import { Select, MenuItem } from '@material-ui/core';

import text from '../../texts/translations';
import Translation from '../Translation/Translation';

const privilegeTypes = [
  'user',
  'manager',
  'admin'
];

export default (props) => {
  return (
    <Select {...props}>
      {privilegeTypes.map((type) => {
        return (
          <MenuItem value={type}><Translation>{`privileges.${type}`}</Translation></MenuItem>
        )
      })}
    </Select>
  )
}



// WEBPACK FOOTER //
// ./src/components/UserPrivilegesSelect/UserPriviligesSelect.jsx